import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/lib/Option';
import * as TE from 'fp-ts/lib/TaskEither';

import StudyApi from '../api/StudyApi';
import { CardHtml } from '../model/domain/CardHtml';
import { DeckCard, Deck, ResourcesItem } from '../model/domain/Deck';
import { NextStep } from '../model/domain/NextStep';
import { Stat } from '../model/domain/Stat';
import { BSTask } from '../model/types';
import { debugIO } from '../util/logger';

const nextStep = (stat: O.Option<Stat>, skipSurvey?: string): BSTask<NextStep> => {
  return pipe(
    StudyApi.nextStep(stat, skipSurvey),
    TE.chainFirst((ns: NextStep) => debugIO('NextStep', ns))
  );
};

const getUserLibraryDecks = (): BSTask<Deck[]> => {
  return pipe(StudyApi.getUserLibraryDecks());
};

const getUserLibraryDeckCards = (deckId: string): BSTask<DeckCard[]> => {
  return pipe(StudyApi.getUserLibraryDeckCards(deckId));
};

const getUserLibraryCard = (cardId: string): BSTask<CardHtml> => {
  return pipe(StudyApi.getUserLibraryCard(cardId));
};

const getUserLibraryResources = (): BSTask<ResourcesItem[]> => {
  return pipe(StudyApi.getUserLibraryResources());
};

export default {
  nextStep,
  getUserLibraryDecks,
  getUserLibraryDeckCards,
  getUserLibraryCard,
  getUserLibraryResources,
};
